import { Fragment } from 'react';
import { parseHighlight } from './highlight';

/**
 * A highlighted value from the search index, rendered as elements.
 *
 * See highlight.ts for why this parses rather than injects.
 */
export function Highlight({
  value,
  fallback = '',
}: {
  value: string | undefined | null;
  fallback?: string;
}) {
  const segments = parseHighlight(value);
  if (segments.length === 0) return <>{fallback}</>;

  return (
    <>
      {segments.map((s, i) => (
        <Fragment key={i}>{s.marked ? <mark>{s.text}</mark> : s.text}</Fragment>
      ))}
    </>
  );
}
